<div class='dialog'>
  <mat-dialog-content class='dialog-content'>
    <p [innerHTML]="data.title"></p>
    <p>Please click
      <a class="hyper-link" (click)="downloadTemplate()">here</a> for further information
    </p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class='btn btn-lg btn-greengo' mat-button [mat-dialog-close]="true">Yes</button>
    <button class='btn btn-lg btn-lead-50' mat-button [mat-dialog-close]="false">No</button>
  </mat-dialog-actions>
</div>